export default "Plan France 2030 Agriculture — Subventions transition | Solution Éco France";
